










import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class UiInputDetails extends Vue { 
  @Prop()
  errorMessages: string[];

  get message() {
    return this.errorMessages && this.errorMessages[0];
  }
}
